export const regionMapping = {
    at: 'eu',
    au: 'oc',
    be: 'eu',
    ca: 'na',
    ch: 'eu',
    cz: 'eu',
    de: 'eu',
    dk: 'eu',
    es: 'eu',
    fi: 'eu',
    fr: 'eu',
    gb: 'eu',
    gr: 'eu',
    ie: 'eu',
    it: 'eu',
    mx: 'na',
    nl: 'eu',
    no: 'eu',
    nz: 'oc',
    pl: 'eu',
    pt: 'eu',
    ro: 'eu',
    se: 'eu',
    us: 'na',
};
